import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { useContext } from 'react';
import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { BankAccountWithCodeValidation } from '@dealstack/frontend/shared/components/BankAccountWithCodeValidation/BankAccountWithCodeValidation.tsx';
import { useInvestmentBankAccountStep } from '@dealstack/frontend/investor/pages/Investment/hooks/useInvestmentBankAccountStep';
import { inferBankCountryCode } from '@dealstack/frontend/shared/components/BankAccountForm/BankAccountForm.utils.ts';
import { getMainAddress } from '@dealstack/frontend/shared/address.ts';
import { Flex } from '@mantine/core';

export const JoinAndAllocationBankAccount = () => {
	const { setIsContinueDisabled, setIsLoading, getInvestorDataRequest } = useContext(
		investmentJoinAndAllocationContext
	);
	const investorPayload = getInvestorDataRequest.response?.payload;
	const pivPersonId = investorPayload?.pivPerson?.id;
	const accountOwner = pivPersonId ? investorPayload?.pivPerson : investorPayload?.person;
	const inferredCountryCode = inferBankCountryCode(
		getMainAddress(accountOwner?.addresses)?.country
	);

	const {
		dealId,
		investmentWorkflowId,
		kycWorkflowId,
		bankAccountsData,
		bankAccountsLoading,
		refetchBankAccounts,
	} = useInvestmentBankAccountStep({
		pivPersonId,
		setIsContinueDisabled,
		setIsLoading,
	});

	return (
		<Flex direction="column" maw="40rem">
			<BankAccountWithCodeValidation
				disableNoAccountAlert={true}
				investmentWorkflowId={investmentWorkflowId}
				kycWorkflowId={kycWorkflowId}
				dealId={dealId}
				personId={pivPersonId}
				bankAccountsData={bankAccountsData}
				bankAccountsLoading={bankAccountsLoading}
				refetchBankAccounts={refetchBankAccounts}
				onMutationFinish={getInvestorDataRequest.fetch}
				dataTestId={TEST_ELEMENT_IDS.BANK_ACCOUNT_FORM}
				inferredCountryCode={inferredCountryCode}
			/>
		</Flex>
	);
};
